module.exports = __webpack_public_path__ + "img/ul.b43e3772.svg";